import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // The full Details form ("Something else") is laid out for a 720px column, so the drawer fits one.
  paper: {
    width: 'min(768px, 100vw)',
    backgroundColor: theme.colorPalette.beige_25,
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(6, 6, 4),
    borderBottom: `1px solid ${theme.colorPalette.beige_60}`
  },
  eyebrow: {
    display: 'block',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: theme.colorPalette.beige_90
  },
  title: {
    margin: theme.spacing(1, 0, 0),
    fontSize: 20,
    fontWeight: 600,
    color: theme.colorPalette.green_100
  },
  close: {
    color: theme.colorPalette.green_100
  },
  body: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(4, 6, 6),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5)
  },
  wait: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    margin: 0,
    color: theme.colorPalette.beige_90
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(3),
    padding: theme.spacing(4, 6),
    borderTop: `1px solid ${theme.colorPalette.beige_60}`
  }
});

export default makeStyles(styles);
